<template>
  <div class="status-station">

    <!-- START Search Box -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3">
                <b-form-group label-class="col-form-label"
                              label="Search" label-for="stationSearchBox"
                              label-cols="3" content-cols="9">
                  <b-input-group>
                    <b-form-input id="stationSearchBox" type="search" v-model="searchWord" @input="resetShowDetails" />
                  </b-input-group>
                </b-form-group>
              </div>
<!--              <div class="col-lg" />-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Search Box -->

    <!-- START Station List -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow mb-0">
          <div class="card-body">

            <div class="row mb-3">
              <div class="col">
                <div class="float-end me-2">
                  <total-count :count="pagination.totalCount" unit="개" />
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <b-table class="datatables text-nowrap" bordered hover
                       :fields="fields" :items="items"
                       :filter="searchWord"
                       :filter-included-fields="filterOn"
                       :filter-debounce="150"
                       :per-page="pagination.perPage"
                       :current-page="pagination.currentPage"
                       :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc"
                       @filtered="onFiltered"
                       @row-clicked="rowClick">

                <template #cell(type)="data">
                  {{ $_utils.isEmpty(data.item.type) ? '-' : data.item.type }}
                </template>
                <template #cell(placeType)="data">
                  {{ $_utils.isEmpty(data.item.placeType) ? '-' : $_app.code.placeType[data.item.placeType] }}
                </template>

                <template #row-details="data">
                  <b-card class="row-detail mb-0">
                    <ul class="mb-0">
                      <li>충전소 ID : <span class="ct-text-main">{{ data.item.placeId }}</span></li>
                      <li>충전소 : <span class="ct-text-main">{{ data.item.placeName }}</span></li>
                      <li>주소 : <span class="ct-text-main">{{ data.item.address }}</span></li>
                      <li>유형 : <span class="ct-text-main">{{ $_utils.isEmpty(data.item.type) ? '-' : data.item.type }}</span></li>
                      <li>상세 유형 : <span class="ct-text-main">{{ $_utils.isEmpty(data.item.placeType) ? '-' : $_app.code.placeType[data.item.placeType] }}</span></li>
                      <li>운영 시간 : <span class="ct-text-main">{{ $_utils.isEmpty(data.item.opTime) ? '-' : data.item.opTime }}</span></li>
                      <li>사용 대상 : <span class="ct-text-main">{{ $_utils.isEmpty(data.item.useTarget) ? '-' : data.item.useTarget }}</span></li>
                      <li>주차 요금 : <span class="ct-text-main">{{ $_utils.isEmpty(data.item.parkFee) ? '-' : data.item.parkFee }}</span></li>
                      <li>위도 : <span class="ct-text-main">{{ data.item.latitude }}</span></li>
                      <li>경도 : <span class="ct-text-main">{{ data.item.longitude }}</span></li>
                      <li>등록일 : <span class="ct-text-main">{{ data.item.regDate }}</span></li>
                      <li>수정일 : <span class="ct-text-main">{{ data.item.modDate }}</span></li>
                    </ul>
                  </b-card>
                </template>
              </b-table>
            </div>

            <div class="row mt-3">
              <div class="col mt-2">
                <b-pagination class="pagination-no-border" size="sm" align="center" v-model="pagination.currentPage"
                              first-number last-number prev-text="<" next-text=">"
                              :total-rows="pagination.totalCount"
                              :per-page="pagination.perPage"
                              @change="resetShowDetails" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Station List -->

  </div>
</template>

<script>
import TotalCount from '@/views/components/totalCount.vue';

export default {
  components: { TotalCount },
  data() {
    const _sApi = this.$_app.service.station;
    return {
      stationApi: _sApi,
      searchWord: null,
      sortBy: 'placeName',
      sortDesc: false,
      filterOn: ['placeId', 'placeName', 'address', 'type', 'placeType'],
      fields: [
        { key: 'placeId', label: '충전소 ID', sortable: true, class: 'text-center' },
        { key: 'placeName', label: '충전소', sortable: true },
        { key: 'address', label: '주소', sortable: true },
        { key: 'type', label: '유형', sortable: true, class: 'text-center' },
        { key: 'placeType', label: '상세 유형', sortable: true, class: 'text-center' }
      ],
      items: [],
      pagination: {
        currentPage: 1,
        totalCount : 0,
        perPage: 10,
      }
    }
  },
  created() {
    const vm = this;
    vm.getItems();
  },
  methods: {
    getItems() {
      const vm = this;

      vm.stationApi.list()
          .then(res => {
            vm.items = res;
            vm.pagination.totalCount = res.length;
          }).catch(err => {
            console.log('Get Station List Error :: ', err);
          });
    },
    onFiltered(filteredItems) {
      const vm = this;

      if (vm.pagination.totalCount !== filteredItems.length) {
        vm.pagination.currentPage = 1;
      }

      vm.pagination.totalCount = filteredItems.length;
    },
    rowClick(row) {
      const vm = this;

      if (row._showDetails) {
        this.$set(row, '_showDetails', false);
      } else {
        vm.items.forEach(item => {
          this.$set(item, '_showDetails', false);
        });

        vm.$nextTick(() => {
          this.$set(row, '_showDetails', true);
        });
      }
    },
    resetShowDetails() {
      const vm = this;

      vm.items.forEach(item => {
        this.$set(item, '_showDetails', false);
      });
    }
  }
}
</script>
